export default __webpack_public_path__ + "static/media/openlink.4cf6c00a.png";